import React from 'react';
import Autocomplete from '../common/AutoComplete';
import DepartmentAutocomplete from '../common/DepartmentAutocomplete';
import NamedAutocomplete from '../common/NamedAutocomplete';
import { useSelector, useDispatch } from 'react-redux';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useRef,useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import store from '../../store';
import { useNavigate,Link,Location, useLocation } from 'react-router-dom';

function VendorUpdateForm() {

	//React.createRef();
	const REQUEST_URL="/PaymentApproval/UpdateVendor";		
	const {auth,setAuth} = useAuth();
	const axiosPrivate = useAxiosPrivate();
	const errRef = useRef();
	const [errMsg, setErrMsg] = useState('');
	
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const locationState = location.state;
	
	const [state, setState] = React.useState({
		id: 0,
		name: "",
		phone: "",
		email:"",
		pan:"",
		gstin:"",
		bankName:"",
		acNo: "",
		ifsc: ""
	});

	useEffect(() => {
		if(!locationState){
		  navigate("/vendors");
		} else {
			setState(
				{
					id: locationState.vendor.id ?? 0,
					name: locationState.vendor.name ?? "",
					phone: locationState.vendor.phone ?? "",
					email: locationState.vendor.email ?? "",
					pan: locationState.vendor.pan ?? "",
					gstin: locationState.vendor.gstin ?? "",
					bankName: locationState.vendor.bankName ?? "",
					acNo: locationState.vendor.acNo ?? "",
					ifsc: locationState.vendor.ifsc ?? "",
				}
			);
		}
	}, [locationState]);

	useEffect(()=>{
		setErrMsg('');
	},[state.name,state.acNo,state.ifsc]);

	function handleChange(evt) {

		// console.log(autocompleteElement.current?.value);
		
		let value = evt.target.value;
		// if(evt.target.name.toLowerCase == 'quantity')
		// {
		// 	val=event.target.value.replace(/\D/g, '');
		// }
		setState({
		  ...state,
		  [evt.target.name]: value
		});
	  };

	function clear()
	{
		setState({
			bankName: "",
			acNo: "",
			ifsc: ""
		  });
	};

	const onCancelClick = (event) =>{
		navigate("/vendors");
	};

	const onSaveClick = async(event) => {
		
		try{

			if(!state.name || !state.bankName || !state.acNo || !state.ifsc)
			{
				setErrMsg('Please input mandatory fields');
				return false;
			}

			clear();

            const requestPaylod = {
                id: state.id,
                name: state.name,
				phone: state.phone,
				email: state.email,
				pan: state.pan,
				gstin: state.gstin,
				bankName: state.bankName,
				acNo: state.acNo,
				ifsc: state.ifsc
			}

            const response = await axiosPrivate.post(REQUEST_URL,requestPaylod,{
                withCredentials: true,
                headers: {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${auth?.accessToken}`
                  //'access-control-allow-origin' : '*'
                }
              })
              .then(response =>{
                navigate("/vendors");
              })
              .catch(error =>{
                console.log(error);
              });
          
        }
        catch(err){

            console.log(err.response);

        }
		
	  };


  return (
    <><form>
		<div className="mb-3 row">
        <p ref={errRef} className={errMsg?'validation':"offscreen"} aria-live='assertive'>{errMsg}</p>
        </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputName" className="col-sm-2 col-form-label">Vendor Name *</label>
			  <div className="col-sm-3">
				<input type="text" name="name" className="form-control" value={state.name} id="inputName" readOnly/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputPhone" className="col-sm-2 col-form-label">Phone</label>
			  <div className="col-sm-3">
				<input type="text" name="phone" className="form-control" value={state.phone} id="inputPhone" readOnly/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Email</label>
			  <div className="col-sm-3">
				<input type="text" name="email" className="form-control" value={state.email} id="inputEmail" readOnly/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputPAN" className="col-sm-2 col-form-label">PAN</label>
			  <div className="col-sm-3">
				<input type="text" name="pan" className="form-control" value={state.pan} id="inputPAN" readOnly/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputGSTIN" className="col-sm-2 col-form-label">GSTIN</label>
			  <div className="col-sm-3">
				<input type="text" name="gstin" className="form-control" value={state.gstin} id="inputGSTIN" readOnly/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputBankName" className="col-sm-2 col-form-label">Bank Name*</label>
			  <div className="col-sm-3">
				<input type="text" name="bankName" className="form-control" onChange={handleChange} value={state.bankName} id="inputBankName"/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputAcNo" className="col-sm-2 col-form-label">Bank Account Number *</label>
			  <div className="col-sm-3">
				  <input type="text" name="acNo" className="form-control" onChange={handleChange} value={state.acNo} id="inputAcNo" />
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputIfsc" className="col-sm-2 col-form-label">IFSC *</label>
			  <div className="col-sm-3">
				  <input type="text" name="ifsc" className="form-control" onChange={handleChange} value={state.ifsc} id="inputIfsc" />
			  </div>
		  </div>
		  <div className="mb-3 row">

			  <div className="col-sm-4">
				  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
					  <button className="btn btn-warning me-md-2" onClick={onCancelClick} type="button">Cancel</button>
					  <button className="btn btn-primary" type="button" onClick={onSaveClick}>Save</button>
				  </div>
			  </div>
		  </div>

	  </form>
	  
	  </>
  )
}

export default VendorUpdateForm